export default "__VITE_ASSET__DvRcs24$__"